/**
 * File containing the DriverInitiativeResponseComponent class.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DriverService } from '../../core/services/driver/driver.service';
import { resetUserToken } from '../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-driver-initiative-response',
    templateUrl: './driver-initiative-response.component.html',
    styleUrls: ['./driver-initiative-response.component.scss'],
})

/**
 * Class representing the DriverInitiativeResponseComponent.
 */
export class DriverInitiativeComponent implements OnInit {
    initiative: string = '';
    token: string = '';
    showError: boolean = false;
    response: string = '';
    email: string = '';
    isVerifying: boolean = true;

    constructor(
        private activeRoute: ActivatedRoute,
        private driverService: DriverService
    ) {
        this.initiative = this.activeRoute.snapshot.params['initiative'];
        this.token = this.activeRoute.snapshot.params['token'];
        this.response = this.activeRoute.snapshot.params['response'];
    }

    ngOnInit(): void {
        resetUserToken();
        this.isVerifying = true;
        if (this.token && this.initiative && this.response) {
            //  Call the backend to verify the initiative and token
            this.driverService
                .verifyInitiative(this.initiative, this.token, this.response)
                .subscribe(
                    (response: any) => {
                        this.showError = !response.success;
                        this.response = response?.data?.driver_response;
                        this.email = response?.data?.email;
                        this.isVerifying = false;
                    },
                    (error) => {
                        if (
                            error?.error?.message ===
                            'Response already submitted.'
                        ) {
                            this.response = 'submitted';
                            this.showError = false;
                        } else {
                            this.showError = true;
                        }
                        this.isVerifying = false;
                    }
                );
        } else {
            this.showError = true;
            this.isVerifying = false;
        }
    }
}
